import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SportContext = createContext(null);

const SPORT_META = {
  squash: { label: "Squash", color: "#CCFF00", accent: "Volt" },
  pickleball: { label: "Pickleball", color: "#FF4500", accent: "Orange" },
};

const STORAGE_KEY = "rl_sport";

export function SportProvider({ children }) {
  const [sport, setSport] = useState("pickleball");
  const [skillsBySport, setSkillsBySport] = useState({ squash: [], pickleball: [] });
  const [sharedSkills, setSharedSkills] = useState([]);
  const [enabledSports, setEnabledSports] = useState(["pickleball"]);
  const [features, setFeatures] = useState({ squash_enabled: false });
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/config").then((r) => {
      setSkillsBySport(r.data.sport_skills || {});
      setSharedSkills(r.data.shared_skills || []);
      const enabled = r.data.enabled_sports || ["pickleball"];
      setEnabledSports(enabled);
      setFeatures(r.data.features || { squash_enabled: false });
      // initialise selected sport from storage if it's still allowed; otherwise default
      const stored = localStorage.getItem(STORAGE_KEY);
      const initial = stored && enabled.includes(stored) ? stored : (r.data.default_sport || enabled[0] || "pickleball");
      setSport(initial);
      localStorage.setItem(STORAGE_KEY, initial);
      setLoaded(true);
    });
  }, []);

  const change = (s) => {
    if (!enabledSports.includes(s)) return;
    setSport(s);
    localStorage.setItem(STORAGE_KEY, s);
  };

  const reloadFeatures = async () => {
    const r = await api.get("/config");
    const enabled = r.data.enabled_sports || ["pickleball"];
    setEnabledSports(enabled);
    setFeatures(r.data.features || { squash_enabled: false });
    if (!enabled.includes(sport)) {
      const fallback = enabled[0] || "pickleball";
      setSport(fallback);
      localStorage.setItem(STORAGE_KEY, fallback);
    }
  };

  return (
    <SportContext.Provider value={{
      sport, setSport: change,
      skills: skillsBySport[sport] || [],
      skillsBySport,
      sharedSkills,
      enabledSports,
      multipleSports: enabledSports.length > 1,
      features, reloadFeatures, loaded,
      meta: SPORT_META[sport],
      allMeta: SPORT_META,
    }}>
      {children}
    </SportContext.Provider>
  );
}

export const useSport = () => useContext(SportContext);
export { SPORT_META };
